import React, { useState, useEffect } from "react";
import { Menu, X } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { NavigationMenu, NavigationMenuItem, NavigationMenuLink, NavigationMenuList } from "@/components/ui/navigation-menu";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
function DesktopNav() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <div className="hidden lg:flex items-center gap-6">
        {[1, 2, 3, 4].map(i => <div key={i} className="h-4 w-20 bg-muted animate-pulse rounded" />)}
      </div>;
  }
  return <NavigationMenu className="hidden lg:flex">
      <NavigationMenuList className="gap-2">
        {menuItems.filter((item, index, self) => {
        if (item.label.toLowerCase() === "dove trovarci") {
          return false;
        }
        if (item.label.toLowerCase() === "lavora con noi") {
          return index === self.findIndex(t => t.label.toLowerCase() === "lavora con noi");
        }
        if (item.href === "/Legal Topics Overview" || item.href === "/Legal Topics Overview Additional" || item.href === "/Responsabilità degli enti 231") {
          return false;
        }
        if (item.label === "News" && item.href === "/news") {
          return false;
        }
        return true;
      }).map((item, i) => <NavigationMenuItem key={item.id} data-index={i}>
              <NavigationMenuLink asChild>
                <Link to={item.label === "Chi siamo" ? "/StudioPage" : item.label === "Home" ? "/" : item.label === "Competenze" ? "/ConsultingPage" : item.href || "#"} className="group relative px-4 py-2 text-sm font-medium text-foreground transition-colors hover:text-foreground/80 focus:outline-none">
                  {item.label === "Competenze" || item.href === "/ConsultingPage" ? "Aree di attività" : item.label === "lavora con noi" ? "Lavora con noi" : item.label}
                  <span className="absolute bottom-0 left-1/2 h-[1px] w-0 -translate-x-1/2 bg-[var(--color-ring)] transition-all duration-300 group-hover:w-full" />
                </Link>
              </NavigationMenuLink>
            </NavigationMenuItem>)}
      </NavigationMenuList>
    </NavigationMenu>;
}
function MobileNav({
  onClose
}: {
  onClose: () => void;
}) {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <div className="flex flex-col gap-4 p-6">
        {[1, 2, 3, 4].map(i => <div key={i} className="h-6 w-32 bg-muted animate-pulse rounded" />)}
      </div>;
  }
  return <nav className="flex flex-col gap-6 p-6">
      {menuItems.filter((item, index, self) => {
      if (item.label.toLowerCase() === "dove trovarci") {
        return false;
      }
      if (item.label.toLowerCase() === "lavora con noi") {
        return index === self.findIndex(t => t.label.toLowerCase() === "lavora con noi");
      }
      if (item.href === "/Legal Topics Overview" || item.href === "/Legal Topics Overview Additional" || item.href === "/Responsabilità degli enti 231") {
        return false;
      }
      if (item.label === "News" && item.href === "/news") {
        return false;
      }
      return true;
    }).map((item, i) => <Link key={item.id} data-index={i} to={item.label === "Chi siamo" ? "/StudioPage" : item.label === "Home" ? "/" : item.label === "Competenze" ? "/ConsultingPage" : item.href || "#"} className="text-lg font-medium text-foreground transition-colors hover:text-[var(--color-ring)]" onClick={onClose}>
            {item.label === "Competenze" || item.href === "/ConsultingPage" ? "Aree di attività" : item.label === "lavora con noi" ? "Lavora con noi" : item.label}
          </Link>)}
    </nav>;
}
export default function Header() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 10);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  useEffect(() => {
    const handleAnchorClick = (e: MouseEvent) => {
      const target = e.target as HTMLElement;
      const anchor = target.closest("a[href]") as HTMLAnchorElement | null;
      if (anchor) {
        const href = anchor.getAttribute("href");
        if (!href) return;
        let hash = "";
        if (href.startsWith("#")) {
          hash = href;
        } else if (href.startsWith("/") && href.includes("#")) {
          const [path, hashPart] = href.split("#");
          if (path === "/" || path === window.location.pathname) {
            hash = "#" + hashPart;
          }
        }
        if (hash && hash !== "#") {
          const element = document.querySelector(hash);
          if (element) {
            e.preventDefault();
            element.scrollIntoView({
              behavior: "smooth",
              block: "start"
            });
            setIsMobileMenuOpen(false);
          }
        }
      }
    };
    document.addEventListener("click", handleAnchorClick);
    return () => document.removeEventListener("click", handleAnchorClick);
  }, []);
  return <header id="header" className={`sticky top-0 z-50 w-full border-b border-transparent transition-all duration-300 ${isScrolled ? "bg-background/80 backdrop-blur-lg border-border/40 shadow-sm" : "bg-background"}`}>
      <div className="container mx-auto flex h-20 items-center justify-between px-4 md:px-6">
        
        <Link to="/" className="flex items-center gap-2">
          <img src="https://topical-falcon.10web.cloud/wp-content/uploads/2026/02/dcl_3-1.png" alt="DCLegal Logo" className="object-contain !w-[80px] !h-[80px]" />
        </Link>

        
        <MenuProvider menu_id="42">
          <DesktopNav />
        </MenuProvider>

        
        <div className="hidden lg:flex items-center gap-2">
          <Button variant="outline" className="border-[var(--color-ring)] text-[var(--color-ring)] hover:bg-[var(--color-ring)] hover:text-background transition-colors" asChild>
            
          </Button>
          <Button variant="outline" className="border-[var(--color-ring)] text-[var(--color-ring)] hover:bg-[var(--color-ring)] hover:text-background transition-colors" asChild>
            
          </Button>
        </div>

        
        <Button variant="ghost" size="icon" className="lg:hidden text-foreground hover:text-[var(--color-ring)] hover:bg-transparent" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} aria-label="Toggle menu">
          {isMobileMenuOpen ? <X className="size-6" /> : <Menu className="size-6" />}
        </Button>
      </div>

      
      <div className={`fixed inset-x-0 top-20 z-40 h-[calc(100vh-5rem)] w-full overflow-y-auto bg-background/95 backdrop-blur-xl transition-transform duration-300 lg:hidden ${isMobileMenuOpen ? "translate-x-0" : "translate-x-full"} !bg-[url(https://studiodclegal.it/wp-content/uploads/2026/03/cell.png)] !bg-[url(https://studiodclegal.it/wp-content/uploads/2026/03/cell.png)]`}>
        <MenuProvider menu_id="42">
          <MobileNav onClose={() => setIsMobileMenuOpen(false)} />
        </MenuProvider>
      </div>
    </header>;
}